module.exports = __webpack_public_path__ + "static/media/ic_searchtype_lagoon.fdd8e289.svg";